<template>
    <main role="main">
        <article class="layout-contents-container">
            <div class="layout-page-title">
                <h1 class="page-title">
                    {{ $t('MENU.AUDIT_HISTORY')}}<!--Audit History-->
                </h1>
            </div>
            <div class="layout-contents">
                <fieldset class="tbl-actions">
                    <legend>table filters</legend>

                    <div class="datepicker">
                        <input type="text" name="rangedates">
                    </div>

                    <select-box-multi select-id="typeFilterx"
                        select-class="go-vendor type-checkbox"
                        place-holder="AUDIT.FILTER.HIST_TYPE"
                        :select-box-options="getLogType"
                        :use-translate="true"
                        :select-box-value="filter.arrHistType"
                        @onSelectChange="changeArrHistType($event.value)">
                    </select-box-multi>


                    <div class="search-box">
                        <input type="search"
                            :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                            v-model="search.srchText"
                            @keyup="setSearchText"
                            class="pr-0">
                        <button v-show="search.srchText !== ''" type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="clear" v-on:click="clearSearchText">Reset</button>
                        <button type="button" class="btn-search" @click="setSearchText">{{ $t('COMMON.SEARCH.ENTER_SEARCH_TEXT')}}<!--검색어 입력--></button>
                    </div>
                </fieldset>

                <div class="tbl-collapse" data-linkable-row>
                    <div class="thead">
                        <div class="row">
                            <span class="cell" data-size="status" data-align="center">
                                <button type="button" class="buttons-tbl-header" data-type="filter" data-tooltip-content="#tooltip-filter">{{ $t('AUDIT.LABEL.HEADER.STATUS')}}<!--상태--></button>
                                <div class="tooltip_templates">
                                    <div id="tooltip-filter">
                                        <ul class="list-filter">
                                            <li>
                                                <input type="checkbox"
                                                    id="filter-error"
                                                    name="filter-type"
                                                    class="checkbox"
                                                    v-model="searchAction"
                                                    value="error">
                                                <label for="filter-error">{{$t('COMPLIANCE.EVAL_STAT.ERROR')}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </span>
                            <span class="cell" data-size="date">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'timeLine' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                        v-on:click="setSortColumn('timeLine')">{{ $t('AUDIT.LABEL.HEADER.DATE')}}<!--일시--></button>
                            </span>
                            <span class="cell" data-size="type">
                                {{ $t('AUDIT.LABEL.HEADER.ACTIVITY_TYPE')}}<!--활동 유형-->
                            </span>
                            <span class="cell" data-size="user">
                                <button type="button" class="buttons-tbl-header" data-type="filter1" data-tooltip-content="#tooltip-filter1">{{ $t('AUDIT.LABEL.HEADER.USER')}}<!--사용자--></button>
                                <div class="tooltip_templates">
                                    <div id="tooltip-filter1">
                                        <ul class="list-filter">
                                            <li>
                                                <input type="checkbox" id="filter-system" name="filter-type" class="checkbox" v-model="searchAction" value="System">
                                                <label for="filter-system">System</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="filter-user" name="filter-type" class="checkbox" v-model="searchAction" value="user">
                                                <label for="filter-user">{{$t('AUDIT.LABEL.HEADER.USER')}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </span>
                            <span class="cell">
                                {{ $t('AUDIT.LABEL.HEADER.DESCRIPTION')}}<!--상세 내용-->
                            </span>
                            <span class="cell" data-align="center">
                                {{ $t('AUDIT.LABEL.HEADER.DETAILS')}}<!--상세-->
                            </span>
                        </div>
                    </div>

                    <div class="tbody">
                        <!-- 규칙 -->
                        <template v-for="(hist, idx) of getintegrationHistoryList">
                            <expand-policy-create v-if="hist.histType == constants.HIST_TYPE.POLICY_CREATE || hist.histType == constants.HIST_TYPE.POLICY_DELETE || hist.histType == constants.HIST_TYPE.POLICY_COPY" :hist-item="hist" :key="idx"></expand-policy-create>
                            <expand-policy-modify v-if="hist.histType == constants.HIST_TYPE.POLICY_MODIFY" :hist-item="hist" :key="idx"></expand-policy-modify>
                            <expand-rule-create v-if="hist.histType == constants.HIST_TYPE.RULE_CREATE || hist.histType == constants.HIST_TYPE.RULE_DELETE || hist.histType == constants.HIST_TYPE.RULE_COPY" :hist-item="hist" :ctg-list="ctgList" :actn-tmplt-list="actnTmpltList" :key="idx"></expand-rule-create>
                            <expand-rule-modify v-if="hist.histType == constants.HIST_TYPE.RULE_MODIFY" :hist-item="hist" :ctg-list="ctgList" :actn-tmplt-list="actnTmpltList" :key="idx"></expand-rule-modify>
                            <expand-whiteList-create v-if="hist.histType == constants.HIST_TYPE.WHITELIST_CREATE" :hist-item="hist" :key="idx"></expand-whiteList-create>
                            <expand-whiteList-modify v-if="hist.histType == constants.HIST_TYPE.WHITELIST_MODIFY" :hist-item="hist" :key="idx"></expand-whiteList-modify>
                            <expand-inspection-create v-if="hist.histType == constants.HIST_TYPE.INSPECTION_ADD" :hist-item="hist" :key="idx"></expand-inspection-create>
                            <expand-inspection-update v-if="hist.histType == constants.HIST_TYPE.INSPECTION_UPDATE" :hist-item="hist" :key="idx"></expand-inspection-update>
                            <expand-compliance-start v-if="hist.histType == constants.HIST_TYPE.COMPLIANCE_START" :hist-item="hist" :common-info-val="commonInfoVal" :key="idx"></expand-compliance-start>
                            <expand-action-execute v-if="hist.histType == constants.HIST_TYPE.ACTION_EXECUTE" :hist-item="hist" :key="idx"></expand-action-execute>
                            <expand-region-update v-if="hist.histType == constants.HIST_TYPE.REGION_UPDATE" :hist-item="hist" :key="idx"></expand-region-update>
                        </template>

                        <div class="row none with-button" v-if="!pending && getintegrationHistoryList.length == 0">
                            <div class="cells">
                                <div class="cell">
                                    {{$t('COMMON.NO_DATA')}}
                                </div>
                            </div>
                        </div>
                        <pagination v-if="paging"
                            :callSetCurPage="setCurrentPage"
                            :callSetRowsPerPage="setRowsPerPage"
                            :totalPage=paging.totalPage
                            :currentPage=paging.currentPage
                            :rowsPerPage=paging.rowPerPage
                        />
                    </div>
                </div>

            </div>
        </article>
        <div-loading v-if="pending" :full="true"></div-loading>
    </main>

</template>

<script>
    import ExpandPolicyCreate       from "./expand/policyCreate.vue"
    import ExpandPolicyModify       from "./expand/policyModify.vue"
    import ExpandRuleCreate         from "./expand/ruleCreate.vue"
    import ExpandRuleModify         from "./expand/ruleModify.vue"
    import ExpandWhiteListCreate    from "./expand/whiteListCreate.vue"
    import ExpandWhiteListModify    from "./expand/whiteListModify.vue"
    import ExpandInspectionCreate   from "./expand/inspectionCreate.vue"
    import ExpandInspectionUpdate   from "./expand/inspectionUpdate.vue"
    import ExpandComplianceStart    from "./expand/complianceStart.vue"
    import ExpandActionExecute      from "./expand/actionExecute.vue"
    import ExpandRegionUpdate      from "./expand/regionUpdate.vue"
    import Pagination               from "../common/Pagination.vue"
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: 'Audit',
        components:{
            'expand-policy-create'      : ExpandPolicyCreate,
            'expand-policy-modify'      : ExpandPolicyModify,
            'expand-rule-create'        : ExpandRuleCreate,
            'expand-rule-modify'        : ExpandRuleModify,
            'expand-whiteList-create'   : ExpandWhiteListCreate,
            'expand-whiteList-modify'   : ExpandWhiteListModify,
            'expand-inspection-create'  : ExpandInspectionCreate,
            'expand-inspection-update'  : ExpandInspectionUpdate,
            'expand-compliance-start'   : ExpandComplianceStart,
            'expand-action-execute'     : ExpandActionExecute,
            'expand-region-update'     : ExpandRegionUpdate,
            'pagination'                : Pagination
        },
        data: function() {
            return {
                message: '메시지',
                search: {
                    userDefiYn: '',
                    srchText: ''
                },
                searchAction:[],
                filter: {
                    arrHistType: [],
                    stDt: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                    endDt: moment(new Date()).format('YYYY-MM-DD')
                },
                sortColumn: '',                                // Sort column
                sortOrder: '',                                 // Sort order
                current: [],
                integrationHistoryList: [],
                ctgList: [],
                actnTmpltList: [],
                pending: false,
                commonInfoVal:{},
                paging:{
                    totalItem: 0,
                    currentPage: 1,
                    rowPerPage: this.constants.NUM.ROW_PER_PAGE,
                    totalPage: 0,
                },
                isFirstLoad:true
            }
        },
        created: function() {
            this.getHistoryInfo();
            this.debouncedSelectIntegrationHistoryList = _.debounce(this.selectIntegrationHistoryList, 1000)
            this.$store.dispatch('sse/completeSseEventSource');
        },
        mounted() {
            this.selectIntegrationHistoryList();
            this.selectCategoryList();
            this.selectActionTemplateList();
            this.commonInfo();
            const self = this;
            $('input[name="rangedates"]').daterangepicker({
                "autoApply": true,
                startDate: moment(self.filter.stDt),
                endDate: moment(self.filter.endDt),
                locale: {
                    format: 'MM/DD/YYYY',
                    "daysOfWeek": ["Sun","Mon","Tue","Wen","Thu","Fri","Sat"],
                }

            }, function(start, end, label) {
                self.filter.stDt = start.format('YYYY-MM-DD')
                self.filter.endDt = end.format('YYYY-MM-DD')

                self.selectIntegrationHistoryList()
            });

            const $filterTarget = $('.buttons-tbl-header[data-type=filter]');
            const $filterTarget1 = $('.buttons-tbl-header[data-type=filter1]');
            $filterTarget.tooltipster({
                animation: 'fade',
                delay: 200,
                side: 'bottom',
                theme: 'go-filter',
                interactive: true,
                trigger: 'click',
                functionBefore: function(instance, helper) {
                    $filterTarget.addClass("selected");
                },
                functionAfter: function(instance, helper) {
                    $filterTarget.removeClass("selected");
                },
            });
            $filterTarget1.tooltipster({
                animation: 'fade',
                delay: 200,
                side: 'bottom',
                theme: 'go-filter',
                interactive: true,
                trigger: 'click',
                functionBefore: function(instance, helper) {
                    $filterTarget1.addClass("selected");
                },
                functionAfter: function(instance, helper) {
                    $filterTarget1.removeClass("selected");
                },
            });
            document.getElementsByClassName("selection dropdown multiple")[0].addEventListener("click", this.clickOnSelection);
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId',
                auditHistory: 'user/auditHistory'
            }),
            getintegrationHistoryList: function() {
                let list = this.integrationHistoryList;

                return list!= null ? list : [];
            },
            selectedPlcyId() {
                return this.$route.query.plcy;
            },
            getLogType() {
                let types = [];
                for (let type of this.constants.HIST_FILTER) {
                    types.push({key: type["key"], val: this.$t('AUDIT.FILTER.'+ type["value"])});
                }
                return types;
            }
        },
        watch:  {
            curCmpnId: function() {
                const filterData = {
                    currentPage: 1,
                }
                this.getUrlData(filterData);
                this.selectIntegrationHistoryList();
            },
            searchAction: function () {
                this.debouncedSelectIntegrationHistoryList();
            },
        },
        beforeRouteLeave(to, from, next) {
            let audit = { isRecall: false };
            if (to.name === 'ComplianceDetailLog') {
                audit = this.auditHistory;
                audit.isRecall = true;
            }
            this.setAuditHistory(audit);
            next();
        },
        methods: {
            ...mapMutations({
                setAuditHistory: "user/setAuditHistory"
            }),
            getHistoryInfo() {
                if (this.auditHistory.isRecall) {
                    this.getUrlData(this.auditHistory);
                }
            },
            getUrlData(dataFilter) {
                this.cmpnId = dataFilter.cmpnId;
                this.search.srchText = dataFilter.srchText;
                this.filter.arrHistType = dataFilter.arrHistType;
                this.filter.stDt = dataFilter.stDt;
                this.filter.endDt = dataFilter.endDt;
                this.rvsnId = dataFilter.rvsnId;
                this.sortOrder = dataFilter.sortOrder;
                this.sortColumn = dataFilter.sortColumn;
                this.statusFilter = dataFilter.statusFilter;
                this.isLimitPage = dataFilter.isLimitPage;
                this.paging.currentPage = dataFilter.currentPage;
                this.paging.rowPerPage = dataFilter.rowPerPage;
                this.selectedPlcyId = dataFilter.selectedPlcyId;
                this.searchAction = dataFilter.statusFilter;
            },
            changeArrHistType(value) {
                this.filter.arrHistType = value;
                this.paging.currentPage = 1;
                this.debouncedSelectIntegrationHistoryList();
            },
            clickOnSelection(e) {
                const firstChildNode = _.get(e, "target.firstChild.nodeName");
                if (firstChildNode !== "SELECT") return;
                const target = document.getElementsByClassName("menu transition")[0];
                const select = document.getElementsByClassName("selection dropdown")[0];
                if (document.getElementsByClassName("menu visible")[0]) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");
                    select.classList.remove("active");
                } else if(document.getElementsByClassName("menu hidden")[0]) {
                    target.classList.remove("hidden");
                    target.classList.add("visible");
                }
            },
            async selectIntegrationHistoryList() {
                this.pending = true;
                var url = !this.selectedPlcyId ? '/api/governance/audit/list' : '/api/governance/audit/list/plcy';
                var header = {
                    'cmpnId': this.curCmpnId,
                    'srchText': this.search.srchText,
                    'arrHistType': this.filter.arrHistType,
                    'stDt': this.filter.stDt,
                    'endDt': this.filter.endDt,
                    'rvsnId': this.selectedPlcyId,
                    'rowPerPage': this.paging.rowPerPage,
                    'currentPage': this.paging.currentPage,
                    'sortOrder': this.sortOrder,
                    'sortColumn' : this.sortColumn,
                    'statusFilter': this.searchAction,
                    'isLimitPage': true
                };
                this.setAuditHistory(header);
                const response = await this.http.post(url, JSON.stringify(header));
                this.integrationHistoryList = response.data.result;
                this.paging = response.data.pagination;
                this.pending = false;
            },
            doHideOrShow: function(intgId) {
                var exec = $('.'+intgId+'_exec').prop('hidden');
                if(exec){
                    $('.'+intgId+'_exec').prop('hidden', false);
                    //$('.'+intgId+'_finish').prop('hidden', false);
                }else{
                    $('.'+intgId+'_exec').prop('hidden', true);
                    //$('.'+intgId+'_finish').prop('hidden', true);
                }
            },
            refreshData: function() {
                this.selectIntegrationHistoryList();
            },
            setJSONParser:function(complianceMap){
                //console.log('complianceMap', complianceMap);
                var resultErrMap;
                if(complianceMap != null && complianceMap.length > 0){
                    var hashMap = JSON.parse(complianceMap);
                    //console.log('hashMap', hashMap);
                    //console.log('comp', hashMap['accCnt']);
                    var keys = Object.keys(hashMap);
                    if(keys.indexOf('accCnt') > -1 || keys.indexOf('condCnt') > -1){
                        for(let key of keys){
                            if(key != 'accCnt' && key != 'condCnt'){
                                //console.log(hashMap[key]);
                                resultErrMap = hashMap[key];
                            }
                        }
                    }else{
                        resultErrMap = hashMap;
                    }

                }
                return JSON.stringify(resultErrMap, null, 2);
            },
            selectCategoryList() {
                var url = `/api/governance/category/list/simple`;
                var body = {
                    "cmpnId": this.curCmpnId
                };

                this.http.post(url, body)
                    .then(response => {
                        this.ctgList = response.data.result;
                    });
            },
            // Action 목록 조회
            selectActionTemplateList() {
                // Action List 초기화
                this.actnTmpltList = [];

                var url = `/api/governance/actn`;
                this.http.get(url)
                    .then(response => {
                        this.actionTemplateList = response.data.result;
                    });
            },
            setSearchText(event) {
                this.paging.currentPage = 1;
                this.search.srchText = event.target.nodeName == 'BUTTON' ? event.target.parentElement.getElementsByTagName('INPUT')[0].value : event.target.value
                this.debouncedSelectIntegrationHistoryList();
            },
            clearSearchText() {
                this.search.srchText = '';
                this.paging.currentPage = 1;
                this.selectIntegrationHistoryList();
            },
            setSortColumn: function (sortColumn) {
                const sortResult = this.Common.setSortColumn(this.sortColumn, this.sortOrder, sortColumn);
                this.sortColumn = sortResult.sortColumn;
                this.sortOrder= sortResult.sortOrder;
                this.refreshData();
            },
            commonInfo: function () {
                var url = `/api/governance/compliance/common/info`
                var header = {
                    'cmpnId': this.curCmpnId,
                    'cmplId': this.cmplId,
                    'rsltId': this.rsltId
                }
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        this.commonInfoVal = result.data;
                    });
            },
            setCurrentPage(e){
                this.paging.currentPage = e;
                this.debouncedSelectIntegrationHistoryList();
            },
            setRowsPerPage(rpp) {
                this.paging.rowPerPage = rpp.rowsPerPage;
                this.paging.currentPage = rpp.currentPage;
                this.debouncedSelectIntegrationHistoryList();
            }
        }

    }
</script>
<style scoped>
.buttons-tbl-header[data-type="filter1"]:after{
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='1024' height='1024' fill='rgb%28176%2C183%2C191%29'%3E%3Cpath d='M757.822 213.334h-492.57c-3.36-.006-6.459 1.71-8.091 4.48s-1.539 6.159.242 8.847L442.094 503.3c4.636 6.938 7.1 14.969 7.111 23.169v266.777c0 9.621 8.269 17.421 18.469 17.421h88.652c10.2 0 18.469-7.799 18.469-17.421V526.469c.01-8.201 2.475-16.232 7.111-23.169l184.691-276.639c1.781-2.688 1.873-6.076.242-8.847s-4.731-4.487-8.091-4.48h-.923z'/%3E%3C/svg%3E");
}
.buttons-tbl-header[data-type="filter1"].selected:after,
.buttons-tbl-header[data-type="filter1"]:active:after {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='1024' height='1024' fill='rgb%286%2C114%2C255%29'%3E%3Cpath d='M757.822 213.334h-492.57c-3.36-.006-6.459 1.71-8.091 4.48s-1.539 6.159.242 8.847L442.094 503.3c4.636 6.938 7.1 14.969 7.111 23.169v266.777c0 9.621 8.269 17.421 18.469 17.421h88.652c10.2 0 18.469-7.799 18.469-17.421V526.469c.01-8.201 2.475-16.232 7.111-23.169l184.691-276.639c1.781-2.688 1.873-6.076.242-8.847s-4.731-4.487-8.091-4.48h-.923z'/%3E%3C/svg%3E");
}
</style>



// WEBPACK FOOTER //
// src/components/audit/audit.vue